import React, { Fragment } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { SignPad } from "Docs/Components";

export default function StateTaxOregonView({
  form,
  errors,
  sign,
  onFormChange,
  onSsnChange,
  onSignature,
  onDateChange,
  setSignContainer,
}) {
  return (
    <div className="row state-tax-oregon-w4">
      <div className="col-md-12">
        <div className="state-tax-section">
          <div className="form-row state-tax-name-row">
            <div className="form-group state-tax-first-name flex-1">
              <span>First name</span>
              <input
                type="text"
                className="form-control"
                field="form.first_name"
                value={form.first_name || ""}
                onChange={onFormChange}
                placeholder="First name"
              />
            </div>
            <div className="form-group state-tax-initial flex-1">
              <span>Initial</span>
              <input
                type="text"
                className="form-control"
                field="form.middle_initial"
                value={form.middle_initial || ""}
                onChange={onFormChange}
                placeholder=""
                maxLength={2}
              />
            </div>
            <div className="form-group state-tax-last-name flex-1">
              <span>Last name</span>
              <input
                type="text"
                className="form-control"
                field="form.last_name"
                value={form.last_name || ""}
                onChange={onFormChange}
                placeholder="Last name"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <span>Social Security number (SSN)</span>
              <input
                type="text"
                className="form-control"
                value={form.ssn || ""}
                onChange={onSsnChange}
                placeholder=" - Enter here - "
                maxLength={11}
              />
            </div>
            <div className="form-group state-tax-redetermination">
              <span className="state-tax-checkbox-label">
                <input
                  type="checkbox"
                  field="form.redetermination"
                  checked={!!form.redetermination}
                  onChange={onFormChange}
                />
                Redetermination
              </span>
            </div>
          </div>
          <div className="form-group">
            <span>Address</span>
            <input
              type="text"
              className="form-control"
              field="form.address"
              value={form.address || ""}
              onChange={onFormChange}
              placeholder="Street address"
            />
          </div>
          <div className="form-row state-tax-address-row">
            <div className="form-group">
              <span>City</span>
              <input
                type="text"
                className="form-control"
                field="form.city"
                value={form.city || ""}
                onChange={onFormChange}
                placeholder="City"
              />
            </div>
            <div className="form-group">
              <span>State</span>
              <input
                type="text"
                className="form-control"
                field="form.state"
                value={form.state || ""}
                onChange={onFormChange}
                placeholder="State"
              />
            </div>
            <div className="form-group">
              <span>ZIP code</span>
              <input
                type="text"
                className="form-control"
                field="form.zip_code"
                value={form.zip_code || ""}
                onChange={onFormChange}
                placeholder="ZIP"
              />
            </div>
          </div>
        </div>

        <div className="disclaimers">
          <strong>Note:</strong> Your eligibility to claim a certain number of
          allowances or an exemption from withholding may be subject to review
          by the Oregon Department of Revenue. Your employer may be required to
          send a copy of this form to the department for review.
        </div>

        <div className="state-tax-section">
          <div className="form-group state-tax-select-one">
            <span>1. Select one:</span>
            <div className="state-tax-checkbox-group">
              <span className="state-tax-checkbox-label">
                <input
                  type="checkbox"
                  field="form.filing_status_single"
                  checked={!!form.filing_status_single}
                  onChange={onFormChange}
                />
                Single
              </span>
              <span className="state-tax-checkbox-label">
                <input
                  type="checkbox"
                  field="form.filing_status_married"
                  checked={!!form.filing_status_married}
                  onChange={onFormChange}
                />
                Married
              </span>
              <span className="state-tax-checkbox-label">
                <input
                  type="checkbox"
                  field="form.filing_status_married_single_rate"
                  checked={!!form.filing_status_married_single_rate}
                  onChange={onFormChange}
                />
                Married, but withhold at the higher single rate.
              </span>
            </div>
            <p className="disclaimers">
              <strong>Note:</strong> Select &quot;Single&quot; if you&apos;re
              married but legally separated or your spouse is a non-U.S. citizen
              without permanent resident status.
            </p>
          </div>

          <div className="form-group state-tax-allowances">
            <span className="state-tax-dotted-label">
              2. Allowances. Enter the number from Worksheet A, line A5,
              Worksheet B, line B9, or Worksheet C, line C6 (see instructions).
              Otherwise, if you aren&apos;t exempt, enter 0.
              <span className="state-tax-dotted-input">
                <input
                  type="text"
                  className="form-control form-control-inline"
                  field="form.allowances"
                  value={form.allowances || ""}
                  onChange={onFormChange}
                />
              </span>
            </span>
          </div>

          <div className="form-group state-tax-additional">
            <span className="state-tax-dotted-label">
              3. Additional amount from Worksheet C, line C10, or other amount
              to withhold from each paycheck
              <span className="state-tax-dotted-input">
                <input
                  type="text"
                  className="form-control form-control-inline"
                  field="form.additional_amount"
                  value={form.additional_amount || ""}
                  onChange={onFormChange}
                />
              </span>
            </span>
          </div>

          <div className="form-group state-tax-exemption">
            <span>
              4. Exemption from withholding. I certify my wages are exempt from
              withholding and I meet the conditions for exemption as stated in
              Form OR-W-4 Instructions. Complete both lines:
            </span>
            <div className="state-tax-exemption-inputs">
              <span className="state-tax-dotted-label">
                • Enter your exemption code from the Exemption chart in Form
                OR-W-4 Instructions
                <span className="state-tax-dotted-input">
                  <input
                    type="text"
                    className="form-control form-control-inline"
                    field="form.exemption_code_4a"
                    value={form.exemption_code_4a || ""}
                    onChange={onFormChange}
                    placeholder=""
                  />
                </span>
              </span>
              <span className="state-tax-dotted-label">
                • Write &quot;Exempt&quot;
                <span className="state-tax-dotted-input">
                  <input
                    type="text"
                    className="form-control form-control-inline"
                    field="form.exempt_4b"
                    value={form.exempt_4b || ""}
                    onChange={onFormChange}
                    placeholder=""
                  />
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="row form-row">
          <div className="col">
            <div className="inputs-col">
              <div className="inputs-head">
                Employee Signature
                <span className="required-star">&#x2A;</span>
              </div>
              <div className="inputs-items">
                <div
                  ref={setSignContainer}
                  className="sign_here"
                >
                  {sign && (
                    <Fragment>
                      <SignPad
                        id="w4EmpSignPad"
                        height={sign.height || 144}
                        width={sign.width || 446}
                        handleSignature={onSignature}
                        signature={form.employee_signature}
                      />
                      <input
                        type="hidden"
                        value={form.employee_signature}
                        name="employee_signature"
                        field="form.employee_signature"
                        required
                      />
                      {errors["form.employee_signature"] && (
                        <label
                          htmlFor="employee_signature"
                          className="error_label"
                        >
                          {errors["form.employee_signature"]}
                        </label>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="inputs-col">
              <div className="inputs-head">
                Date<span className="required-star">&#x2A;</span>
              </div>
              <div className="inputs-items">
                <DatePicker
                  className={`${errors["form.signed_date"] ? "error" : ""} w-100`}
                  name="signed_date"
                  id="signed_date"
                  required
                  selected={moment(form.signed_date)}
                  field="form.signed_date"
                  placeholder="mm/dd/yyyy"
                  onChange={(date) => onDateChange("form.signed_date", date)}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  autoComplete="off"
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row form-row last">
          <div className="col">
            <div className="inputs-col">
              <div className="check_radio_group check_disclaimer">
                <div className="check_radio_item">
                  <input
                    type="checkbox"
                    name="disclaimer_check"
                    id="disclaimer_check"
                    field="form.disclaimer_check"
                    checked={form.disclaimer_check}
                    onChange={onFormChange}
                    required
                  />
                  <span className="checkbox_checkbox"></span>
                  <label htmlFor="disclaimer_check">
                    I have confirmed the above details are true and valid.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
